const { mapLineItemsToSalesOrderRequestItem } = require('./mappings');

const toSubscriptionUpdateRequest = (order) => {
    return {
        OrderAction: order.action || 'MANAGE',
        Reason: order.reason || 'STANDARD',
        ...(order.adr && order.adr.adrOverrideId && {ADROverrideID: order.adr.adrOverrideId}),
        CountryCode: order.countryCode,
        SoldToMemberID: order.soldToMemberId,
        Item: mapLineItemsToSalesOrderRequestItem(order)
    }
};

module.exports = toSubscriptionUpdateRequest;
